import { useState } from "react";
import { toast } from "react-toastify";
import { CustomerData } from "./useCustomerSearch";
import api from "../../../../../../features/auth/axiosConfig";
import { notifySuccess } from "../../../../../../assets/toastService";
import { isValidEmail } from "../../../../../utils/removeEmoji";

interface UseCustomerFormProps {
  onSuccess: (customer: CustomerData) => void; // Called after successful add
  onBack: () => void;
}

export const useCustomerForm = ({ onSuccess, onBack }: UseCustomerFormProps) => {
  const [formData, setFormData] = useState({ name: "", phone: "", altPhone: "", email: "", address1: "", address2: "", pincode: "", osb: "" });
  const [emailError, setEmailError] = useState(false);
  const [errorEmailExists, setErrorEmailExists] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleInputChange = (field: keyof typeof formData, value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleAddCustomer = async () => {
    // const regex = /^[a-zA-Z0\s]*$/;
    // if (!regex.test(formData.name)) {
    //   toast.error("Special characters are not allowed in name.");
    //   return;
    // }
    if (!formData.name || !formData.phone) {
      toast.error("Please fill in required fields.");
      return;
    }

    setSubmitting(true);

    const customerData = {
      Name: formData.name,
      phone_number: formData.phone,
      alternativenumber: formData.altPhone,
      Email: formData.email,
      Out_standing_balance: Number(formData.osb) ?? 0.0,
      Address: {
        address1: formData.address1,
        address2: formData.address2,
        pincode: formData.pincode,
      },
    };

    try {
      const res = await api.post(`/app/v1/pos/customer`, customerData);
      const created: CustomerData = res.data.customer as CustomerData;
      notifySuccess("Customer added successfully");
      onSuccess(created);
      setTimeout(onBack, 500);
    } catch (err: any) {
      const message = err?.response?.data?.message || "Something went wrong";
      if (message === "Alternative number must be different from phone number") {
        toast.error("Alternative number must be different from phone number");
      } else if (message.includes("Phone Number")) {
        toast.error("Phone number already exists.");
      } else if (message.includes("Alternate") || message.includes("Alternative")) {
        toast.error("Alternate phone number already exists.");
      } else if (message.includes("Email")) {
        setEmailError(true);
        setErrorEmailExists(true);
      } else {
        toast.error(message);
      }
    } finally {
      setSubmitting(false);
    }
  };

  const validateEmail = (email: string, resetExists?: boolean) => {
    if (resetExists) setErrorEmailExists(false); // reset "email already exists"
    setEmailError(!isValidEmail(email) && email !== "");
  };

  const resetForm = () => {
    setFormData({ name: "", phone: "", altPhone: "", email: "", address1: "", address2: "", pincode: "", osb: "" });
    setEmailError(false);
    setErrorEmailExists(false);
  };

  return {
    formData,
    emailError,
    errorEmailExists,
    submitting,
    handleInputChange,
    handleAddCustomer,
    validateEmail,
    resetForm,
  };
};
